<div class="mt-20 ml-72 mb-20">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
</div>
<div class="bookmark mt--18">
  <img class="tag" src="/assets/images/tag.svg" />
  <span class="mat-body fs-12 fw-500 tag-text">{{'TENANT_DETAILS.SHARED_SERVICES' | transloco}}</span>
</div>
<div class="flex flex-row items-center justify-between en-header pt-20 pl-72 pb-20 pr-72">
  <div class="flex">
    <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-6"
      [routerLink]="['/', authService.principal.provider, RouterSegments.TENANT, tenantId, RouterSegments.SHARED_SERVICES]"></mat-icon>
    <div class="flex flex-col flex-auto pl-24">
      <div class="mat-subtitle-1 fw-600 mb-12">
        {{(dataZone === 'pii' ? ('TENANT_LIST.PII' | transloco)
        : (dataZone === 'prod' ? ('TENANT_LIST.PROD' | transloco)
        : (dataZone === 'nonpii' ? ('TENANT_LIST.NON_PII' | transloco)
        : ('TENANT_LIST.NON_PROD' | transloco)
        )))}}
        <span class="pl-6">{{'TENANT_DETAILS.SHARED_SERVICES' | transloco}}</span>
        <span class="datazone mat-subtitle-2 ml-24 fs-14">{{(dataZone === 'pii' ? ('TENANT_LIST.PII' | transloco)
          : (dataZone === 'prod' ? ('TENANT_LIST.PROD' | transloco)
          : (dataZone === 'nonpii' ? ('TENANT_LIST.NON_PII' | transloco)
          : ('TENANT_LIST.NON_PROD' | transloco)
          )))}}</span>
      </div>
      <div class="flex flex-row items-center">
        <div class="vertical-indicator pr-16 flex items-center">{{'INSTANCE_DETAILS.SOLUTION_NAME' | transloco}}:<span
            *ngIf="!isLoading; else loader" class="pl-6">{{solution?.name ? solution?.name : '-'}}</span></div>
        <ng-template #loader>
          <div class="pl-6 pe-skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
        <div class="flex flex-row justify-center items-center ml-16 pr-16">
          {{'INSTANCE_DETAILS.SOLUTION_VERSION' | transloco}}:<span *ngIf="!isLoading; else loader"
            class="pl-6">{{currentVersion?.version ? currentVersion?.version : '-'}}</span>
        </div>
      </div>
    </div>
  </div>

  <!--<div>
    <div class="actions pl-12 pr-12 flex items-center cursor-pointer" [matMenuTriggerFor]="sharedServiceMenu">
      <span class="mat-subtitle-1 fw-700 fs-16 mb-0">{{'TENANT_DETAILS.ACTIONS' | transloco}}</span>
      <mat-icon svgIcon="expand_more" class="ml-8 icon-md-1"></mat-icon>
    </div>
    <mat-menu #sharedServiceMenu class="context-menu-dropdown pe">
      <button class="menu-button">
        <div class="flex flex-row justify-start items-center">
          <mat-icon svgIcon="play_circle" class="icon-md"></mat-icon>
          <div class="mat-body fw-500 fs-16">{{ 'TENANT_DETAILS.START_INSTANCE' | transloco }} </div>
        </div>
      </button>
      <mat-divider class="neutral-blue-6 w-100-percent mt-4 mb-4"></mat-divider>
      <button class="menu-button delete">
        <div class="flex flex-row justify-start items-center">
          <mat-icon svgIcon="stop_circle" class="icon-md delete flex items-center gap-2"></mat-icon>
          <div class="mat-body fw-500 fs-16">{{ 'TENANT_DETAILS.STOP_INSTANCE' | transloco }}</div>
        </div>
      </button>
    </mat-menu>
  </div>-->
</div>

<div *ngIf="!isLoading; else loadingCircle" class="pt-24 pl-72 pr-72 pb-24">
  <mat-tab-group class="upload-cert-tab" animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="section-label fw-500">{{'SHARED_SERVICES.OVERVIEW' | transloco }}</span>
      </ng-template>
      <div *ngIf="dataZone === 'nonpii' && tenantDetails?.sharedServices?.nonpii" class="tab-content pt-12 pl-24 pr-24">
        <div class="flex flex-row flex-wrap gap-30 mb-12">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-subtitle-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_ID' |
              transloco}}<span>:</span></div>
            <div class="overview-values fw-400">
              <span>{{tenantDetails?.sharedServices?.nonpii?.instanceId ?
                tenantDetails?.sharedServices?.nonpii?.instanceId : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-subtitle-2 fs-16 fw-600">{{'TENANT_DETAILS.DEPLOYED_STATUS' |
              transloco}}<span>:</span></div>
            <div class="fw-500">
              <span [ngClass]="tenantDetails?.sharedServices?.nonpii?.instanceDetails?.status" class="flex pl-10 pr-12">
                <mat-card
                  *ngIf="tenantDetails?.sharedServices?.nonpii.instanceDetails?.status === DeployStatus.STARTING || tenantDetails?.sharedServices?.nonpii.instanceDetails?.status === DeployStatus.STOPPING"
                  class="flex spinner-container spinner">
                  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
                </mat-card>
                <mat-icon
                  *ngIf="tenantDetails?.sharedServices?.nonpii?.instanceDetails?.status === DeployStatus.DEPLOYED"
                  svgIcon="check_circle" class="icon-md mr-4" [ngClass]="element?.status"></mat-icon>
                {{tenantDetails?.sharedServices?.nonpii?.instanceDetails?.status ?
                (tenantDetails?.sharedServices?.nonpii?.instanceDetails?.status | titlecase) : '--' }}
              </span>
              <mat-progress-bar
                *ngIf="tenantDetails?.sharedServices?.nonpii?.instanceDetails?.status | isIn: inprogressStatus"
                class="mt-2 progress-bar" mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_NAME' |
              transloco}}<span>:</span></div>
            <div class="overview-values fw-400">
              <span [ngClass]="{'hyper-link': tenantDetails?.sharedServices?.nonpii?.instanceDetails?.name}"
                (click)="goToInstanceSummary(tenantDetails?.sharedServices?.nonpii?.instanceDetails)">{{tenantDetails?.sharedServices?.nonpii?.instanceDetails?.name
                ? tenantDetails?.sharedServices?.nonpii?.instanceDetails?.name : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.RANDOM_SUFFIX' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span>{{tenantDetails?.sharedServices?.nonpii?.randomSuffix ?
                tenantDetails?.sharedServices?.nonpii?.randomSuffix : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.KEYCLOAK_URL' |
              transloco}}<span>:</span></div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonpii?.keycloakUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonpii?.keycloakUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.nonpii?.keycloakUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonpii?.keycloakUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.nonpii?.keycloakUrl}}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonpii?.keycloakUrl"
                  class="icon-width ml-6 cursor-pointer" [ngClass]="[copyKeycloak ? 'copied': 'copy']"
                  [svgIcon]="copyKeycloak ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.nonpii?.keycloakUrl, 'keycloak')"></mat-icon>
              </div>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.GITLAB_URL' | transloco}}<span>:</span>
            </div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonpii?.gitlabUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonpii?.gitlabUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.nonpii?.gitlabUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonpii?.gitlabUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.nonpii?.gitlabUrl }}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonpii?.gitlabUrl"
                  class="icon-width ml-6 cursor-pointer" [ngClass]="[copyGitLab ? 'copied': 'copy']"
                  [svgIcon]="copyGitLab ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.nonpii?.gitlabUrl, 'gitlab')"></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="dataZone === 'nonprod' && tenantDetails?.sharedServices?.nonprod"
        class="tab-content pt-12 pl-24 pr-24">
        <div class="flex flex-row flex-wrap gap-30 mb-12">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_ID' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span>{{tenantDetails?.sharedServices?.nonprod?.instanceId ?
                tenantDetails?.sharedServices?.nonprod?.instanceId : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.DEPLOYED_STATUS' |
              transloco}}<span>:</span></div>
            <div class="fw-500">
              <span [ngClass]="tenantDetails?.sharedServices?.nonprod?.instanceDetails?.status"
                class="flex pl-10 pr-12">
                <mat-card
                  *ngIf="tenantDetails?.sharedServices?.nonprod.instanceDetails?.status === DeployStatus.STARTING || tenantDetails?.sharedServices?.nonprod.instanceDetails?.status === DeployStatus.STOPPING"
                  class="flex spinner-container spinner">
                  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
                </mat-card>
                <mat-icon
                  *ngIf="tenantDetails?.sharedServices?.nonprod?.instanceDetails?.status === DeployStatus.DEPLOYED"
                  svgIcon="check_circle" class="icon-md mr-4" [ngClass]="element?.status"></mat-icon>
                {{tenantDetails?.sharedServices?.nonprod?.instanceDetails?.status ?
                (tenantDetails?.sharedServices?.nonprod?.instanceDetails?.status | titlecase) : '--' }}
              </span>
              <mat-progress-bar
                *ngIf="tenantDetails?.sharedServices?.nonprod?.instanceDetails?.status | isIn: inprogressStatus"
                class="mt-2 progress-bar" mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_NAME' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span [ngClass]="{'hyper-link': tenantDetails?.sharedServices?.nonprod?.instanceDetails?.name}"
                (click)="goToInstanceSummary(tenantDetails?.sharedServices?.nonprod?.instanceDetails)">{{tenantDetails?.sharedServices?.nonprod?.instanceDetails?.name
                ? tenantDetails?.sharedServices?.nonprod?.instanceDetails?.name : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.RANDOM_SUFFIX' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span>{{tenantDetails?.sharedServices?.nonprod?.randomSuffix ?
                tenantDetails?.sharedServices?.nonprod?.randomSuffix : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.KEYCLOAK_URL' |
              transloco}}<span>:</span></div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonprod?.keycloakUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonprod?.keycloakUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.nonprod?.keycloakUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonprod?.keycloakUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.nonprod?.keycloakUrl}}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonprod?.keycloakUrl"
                  class="icon-width ml-6 cursor-pointer" [ngClass]="[copyKeycloak ? 'copied': 'copy']"
                  [svgIcon]="copyKeycloak ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.nonprod?.keycloakUrl, 'keycloak')"></mat-icon>
              </div>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.GITLAB_URL' | transloco}}<span>:</span>
            </div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonprod?.gitlabUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonprod?.gitlabUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.nonprod?.gitlabUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.nonprod?.gitlabUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.nonprod?.gitlabUrl }}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.nonprod?.gitlabUrl"
                  class="icon-width ml-6 cursor-pointer" [ngClass]="[copyGitLab ? 'copied': 'copy']"
                  [svgIcon]="copyGitLab ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.nonprod?.gitlabUrl, 'gitlab')"></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="dataZone === 'pii' && tenantDetails?.sharedServices?.pii" class="tab-content pt-12 pl-24 pr-24">
        <div class="flex flex-row flex-wrap gap-30 mb-12">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_ID' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span>{{tenantDetails?.sharedServices?.pii?.instanceId ? tenantDetails?.sharedServices?.pii?.instanceId :
                '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.DEPLOYED_STATUS' |
              transloco}}<span>:</span></div>
            <div class="fw-500">
              <span [ngClass]="tenantDetails?.sharedServices?.pii?.instanceDetails?.status" class="flex pl-10 pr-12">
                <mat-card
                  *ngIf="tenantDetails?.sharedServices?.pii.instanceDetails?.status === DeployStatus.STARTING || tenantDetails?.sharedServices?.pii.instanceDetails?.status === DeployStatus.STOPPING"
                  class="flex spinner-container spinner">
                  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
                </mat-card>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.pii?.instanceDetails?.status === DeployStatus.DEPLOYED"
                  svgIcon="check_circle" class="icon-md mr-4" [ngClass]="element?.status"></mat-icon>
                {{tenantDetails?.sharedServices?.pii?.instanceDetails?.status ?
                (tenantDetails?.sharedServices?.pii?.instanceDetails?.status | titlecase) : '--' }}
              </span>
              <mat-progress-bar
                *ngIf="tenantDetails?.sharedServices?.pii?.instanceDetails?.status | isIn: inprogressStatus"
                class="mt-2 progress-bar" mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_NAME' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span [ngClass]="{'hyper-link': tenantDetails?.sharedServices?.pii?.instanceDetails?.name}"
                (click)="goToInstanceSummary(tenantDetails?.sharedServices?.pii?.instanceDetails)">{{tenantDetails?.sharedServices?.pii?.instanceDetails?.name
                ? tenantDetails?.sharedServices?.pii?.instanceDetails?.name : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.RANDOM_SUFFIX' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span>{{tenantDetails?.sharedServices?.pii?.randomSuffix ?
                tenantDetails?.sharedServices?.pii?.randomSuffix : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.KEYCLOAK_URL' |
              transloco}}<span>:</span></div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.pii?.keycloakUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.pii?.keycloakUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.pii?.keycloakUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.pii?.keycloakUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.pii?.keycloakUrl}}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.pii?.keycloakUrl" class="icon-width ml-6 cursor-pointer"
                  [ngClass]="[copyKeycloak ? 'copied': 'copy']" [svgIcon]="copyKeycloak ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.pii?.keycloakUrl, 'keycloak')"></mat-icon>
              </div>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.GITLAB_URL' | transloco}}<span>:</span>
            </div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.pii?.gitlabUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.pii?.gitlabUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.pii?.gitlabUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.pii?.gitlabUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.pii?.gitlabUrl }}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.pii?.gitlabUrl" class="icon-width ml-6 cursor-pointer"
                  [ngClass]="[copyGitLab ? 'copied': 'copy']" [svgIcon]="copyGitLab ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.pii?.gitlabUrl, 'gitlab')"></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="dataZone === 'prod' && tenantDetails?.sharedServices?.prod" class="tab-content pt-12 pl-24 pr-24">
        <div class="flex flex-row flex-wrap gap-30 mb-12">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_ID' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span>{{tenantDetails?.sharedServices?.prod?.instanceId ? tenantDetails?.sharedServices?.prod?.instanceId
                : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.DEPLOYED_STATUS' |
              transloco}}<span>:</span></div>
            <div class="fw-500">
              <span [ngClass]="tenantDetails?.sharedServices?.prod?.instanceDetails?.status" class="flex pl-10 pr-12">
                <mat-card
                  *ngIf="tenantDetails?.sharedServices?.prod.instanceDetails?.status === DeployStatus.STARTING || tenantDetails?.sharedServices?.prod.instanceDetails?.status === DeployStatus.STOPPING"
                  class="flex spinner-container spinner">
                  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
                </mat-card>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.prod?.instanceDetails?.status === DeployStatus.DEPLOYED"
                  svgIcon="check_circle" class="icon-md mr-4" [ngClass]="element?.status"></mat-icon>
                {{tenantDetails?.sharedServices?.prod?.instanceDetails?.status ?
                (tenantDetails?.sharedServices?.prod?.instanceDetails?.status | titlecase) : '--' }}
              </span>
              <mat-progress-bar
                *ngIf="tenantDetails?.sharedServices?.prod?.instanceDetails?.status | isIn: inprogressStatus"
                class="mt-2 progress-bar" mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.INSTANCE_NAME' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span [ngClass]="{'hyper-link': tenantDetails?.sharedServices?.prod?.instanceDetails?.name}"
                (click)="goToInstanceSummary(tenantDetails?.sharedServices?.prod?.instanceDetails)">{{tenantDetails?.sharedServices?.prod?.instanceDetails?.name
                ? tenantDetails?.sharedServices?.prod?.instanceDetails?.name : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.RANDOM_SUFFIX' |
              transloco}}<span>:</span></div>
            <div class="overview-values">
              <span>{{tenantDetails?.sharedServices?.prod?.randomSuffix ?
                tenantDetails?.sharedServices?.prod?.randomSuffix : '--'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.KEYCLOAK_URL' |
              transloco}}<span>:</span></div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.prod?.keycloakUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.prod?.keycloakUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.prod?.keycloakUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.prod?.keycloakUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.prod?.keycloakUrl}}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.prod?.keycloakUrl"
                  class="icon-width ml-6 cursor-pointer" [ngClass]="[copyKeycloak ? 'copied': 'copy']"
                  [svgIcon]="copyKeycloak ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.prod?.keycloakUrl, 'keycloak')"></mat-icon>
              </div>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fs-16 fw-600">{{'TENANT_DETAILS.GITLAB_URL' | transloco}}<span>:</span>
            </div>
            <div class="flex flex-row overview-values">

              <div class="flex flex-row items-center">
                <mat-icon *ngIf="tenantDetails?.sharedServices?.prod?.gitlabUrl"
                  class="icon-width mr-6 cursor-pointer visibility" svgIcon="open_in_new"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.prod?.gitlabUrl)"></mat-icon>
                <a *ngIf="tenantDetails?.sharedServices?.prod?.gitlabUrl; else empty"
                  (click)="urlService.openUrlInNewTab(tenantDetails?.sharedServices?.prod?.gitlabUrl)"
                  class="underline">{{tenantDetails?.sharedServices?.prod?.gitlabUrl }}</a>
                <ng-template #empty>-</ng-template>
                <mat-icon *ngIf="tenantDetails?.sharedServices?.prod?.gitlabUrl" class="icon-width ml-6 cursor-pointer"
                  [ngClass]="[copyGitLab ? 'copied': 'copy']" [svgIcon]="copyGitLab ? 'check' : 'content_copy'"
                  (click)="onCopyId(tenantDetails?.sharedServices?.prod?.gitlabUrl, 'gitlab')"></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngIf="!(tenantDetails?.cloudProvider === 'AWS' || tenantDetails?.targetCloud === 'AWS')">
      <ng-template mat-tab-label>
        <span class="section-label fw-500">{{'SHARED_SERVICES.EXTERNAL_MQ_CERTIFICATE' | transloco }}</span>
      </ng-template>
      <div
        *ngIf="((dataZone === 'nonpii' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII]) || (dataZone === 'pii' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII]) || (dataZone === 'prod' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE])) && (piiDownload || prodDownload || nonPiiDownload || nonProdDownload)"
        class="flex flex-row justify-between mb-12">
        <div></div>
        <div class="flex flex-row p-6 download-button-color cursor-pointer" (click)="downloadFile()">
          <mat-icon svgIcon="file_download" class="flex"></mat-icon>{{'SHARED_SERVICES.EXTERNAL_MQ_CERTIFICATE_DOWNLOAD'
          | transloco }}
        </div>
      </div>
      <div>
        <div class="upload flex items-center justify-center">
          <label style="display: none;">
            <input id="upload_file" type="file" #file (change)="onChange($event)">
          </label>
          <div *ngIf="!currentFile" class="flex items-center justify-center">
            <mat-icon class="icon-md mr-6 cursor-pointer" svgIcon="upload_file" [ngClass]="{'disabled': uploadDisable}"
              (click)="!uploadDisable ? selectFile() : ''"></mat-icon>
            <div class="mat-subtitle-1 fw-400 fs-16 choose-section mb-0 cursor-pointer"
              [ngClass]="{'disabled': uploadDisable}" [innerHTML]="'SHARED_SERVICES.CHOOSE_ONLY' | transloco"
              (click)="!uploadDisable ? selectFile() : ''"></div>
          </div>
          <div *ngIf="currentFile" class="flex items-center">
            <span>{{currentFile[0]?.name}}</span>
            <mat-icon *ngIf="!uploadDisable" class="icon-sm ml-16 cursor-pointer close-icon p-2" svgIcon="close"
              (click)="removeFile()"></mat-icon>
          </div>
        </div>
        <span *ngIf="currentFile" class="upload-btn">
          <button class="accent flex items-center fw-500" type="button"
            [ngClass]="{'disabled': uploadDisable || formatError, 'disabled-opacity': !((dataZone === 'nonpii' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII]) || (dataZone === 'pii' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII]) || (dataZone === 'prod' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE]))}"
            (click)="(!uploadDisable && !formatError) ? uploadFile() : ''"><mat-icon class="icon-md mr-6 cursor-pointer"
              svgIcon="upload"></mat-icon>{{'SHARED_SERVICES.UPLOAD' | transloco }}</button>
          <div
            *ngIf="!((dataZone === 'nonpii' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII]) || (dataZone === 'pii' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII]) || (dataZone === 'prod' && permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE]))"
            class="lock-icon"><mat-icon matTooltipClass="above" matTooltipPosition="above"
              [matTooltip]="'DISASTER_RECOVERY.TOOLTIP_MESSAGE' | transloco" svgIcon="lock" class="icon-md"></mat-icon>
          </div>
        </span>
        <div class="format-error fw-500" *ngIf="currentFile && formatError"
          [innerHTML]="'SHARED_SERVICES.ERROR_MESSAGE' | transloco"></div>

        <div class="upload-table" [ngClass]="{'mt-32': !currentFile}">
          <ng-container *ngIf="uploadTableData?.filteredData?.length > 0">
            <table mat-table [dataSource]="uploadTableData" class="w-100-percent">
              <ng-container matColumnDef="fileName">
                <th mat-header-cell *matHeaderCellDef>{{'SHARED_SERVICES.FILE_NAME' | transloco | uppercase}}</th>
                <td mat-cell *matCellDef="let element" class="name cursor-pointer">
                  <div>{{element?.fileName | titlecase}}
                    <span *ngIf="element?.status === 'added' && element.isActive"
                      class="active-tag mat-subtitle-1 fs-10 fw-700 pt-4 pb-4 pl-6 pr-6 ml-8 mb-0">{{'SHARED_SERVICES.ACTIVE'
                      | transloco | uppercase}}</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="version">
                <th mat-header-cell *matHeaderCellDef>{{'SHARED_SERVICES.VERSION' | transloco | uppercase}}</th>
                <td mat-cell *matCellDef="let element" class="version">
                  <div class="flex items-center">
                    {{element?.version ? element?.version : '-'}}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef>{{'SHARED_SERVICES.UPLOAD_DATE' | transloco | uppercase}}</th>
                <td mat-cell *matCellDef="let element" class="version">
                  <div class="flex items-center">
                    {{element?.time ? (element?.time | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{'SHARED_SERVICES.STATUS' | transloco | uppercase}}</th>
                <td mat-cell *matCellDef="let element"
                  [ngClass]="{'grey-out': (element?.status === 'added' && !element.isActive)}">
                  <div class="flex items-center status pl-8 pr-12 pt-2 pb-2" [ngClass]="element?.status">
                    <span>
                      <mat-icon *ngIf="element?.status === 'added'" svgIcon="check_circle" class="icon-md p-2 mr-6"
                        [ngClass]="element?.status"></mat-icon>
                      <mat-icon *ngIf="element?.status === 'failed'" svgIcon="close" class="icon-md p-2 mr-6"
                        [ngClass]="element?.status"></mat-icon>
                      <mat-spinner *ngIf="element?.status === 'adding'" diameter="16" class="mr-8"
                        [ngClass]="element?.status" mode="indeterminate">
                      </mat-spinner>
                    </span>
                    <span class="fw-400">{{element?.status === 'adding' ? ('SHARED_SERVICES.UPLOADING' | transloco) :
                      element?.status === 'added' ? ('SHARED_SERVICES.UPLOADED' | transloco) : (element?.status |
                      titlecase)}}</span>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="instanceBySerDefColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: instanceBySerDefColumns;"></tr>
            </table>
          </ng-container>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #loadingCircle>
  <div class="flex items-center justify-center spinner">
    <mat-spinner diameter="24" color="primary" mode="indeterminate">
    </mat-spinner>
  </div>
</ng-template>